export default {
  'reservationSettings.title': '预约',
  'reservationSettings.section.enable.google.reservation': 'Google在线预约',
  'reservationSettings.section.enable.google.reservation.desc': '将于次日5am～7am生效',
  'reservationSettings.section.capacity': '可在线预约人数',
  'reservationSettings.section.capacity.sub': '可预约人数',
  'reservationSettings.section.capacity.max': '最多',
  'reservationSettings.section.capacity.min': '至少',
  'reservationSettings.section.interval': '预约间隔',
  'reservationSettings.section.interval.sub': '间隔',
  'reservationSettings.section.interval.unit': '分钟',
  'reservationSettings.section.capacity.min.required': '最小可在线预约人数不能为空',
  'reservationSettings.section.capacity.max.required': '最大可在线预约人数不能为空',
  'reservationSettings.section.capacity.range.error': `最小可预约人数不能大于最大可预约人数`,
  'reservationSettings.section.capacity.max.range.error': `最大可预约人数不能超过20`,
  'reservationSettings.section.capacity.interval.required': `预约间隔不能为空`,
  'reservationSettings.section.capacity.interval.range.error': `预约间隔不能小于{minInterval}分钟`,

  'reservationSettings.section.tableSetting': '桌型设置',
  'reservationSettings.section.tableSetting.addNew.button': '添加',
  'reservationSettings.section.tableSetting.edit.button': '编辑',
  'reservationSettings.section.tableSetting.delete.button': '删除',
  'reservationSettings.section.tableSetting.table.column.tableName.cn': '桌名(中文)',
  'reservationSettings.section.tableSetting.table.column.tableName.en': '桌名(英文)',
  'reservationSettings.section.tableSetting.table.column.seatingCapacity': '就餐人数',
  'reservationSettings.section.tableSetting.table.column.duration': '翻台时间(分钟)',
  'reservationSettings.section.tableSetting.table.column.action': '操作',
  'reservationSettings.section.tableSetting.operation.edit': '编辑',

  'reservationSettings.section.tableSetting.modal.new.title': '新桌型',
  'reservationSettings.section.tableSetting.modal.tableName': '桌名',
  'reservationSettings.section.tableSetting.modal.tableName.cn': '中文',
  'reservationSettings.section.tableSetting.modal.tableName.en': '英文',
  'reservationSettings.section.tableSetting.modal.tableName.cn.duplicated.error': `中文桌名有重复`,
  'reservationSettings.section.tableSetting.modal.tableName.en.duplicated.error': `英文桌名有重复`,
  'reservationSettings.section.tableSetting.modal.seatingCapacity': '就餐人数',
  'reservationSettings.section.tableSetting.modal.seatingCapacity.min': '最少',
  'reservationSettings.section.tableSetting.modal.seatingCapacity.max': '最多',
  'reservationSettings.section.tableSetting.modal.seatingCapacity.min.required': '就餐人数(min)不能为空',
  'reservationSettings.section.tableSetting.modal.seatingCapacity.max.required': '就餐人数(max)不能为空',
  'reservationSettings.section.tableSetting.modal.tableName.cn.required': '中文桌名不能为空',
  'reservationSettings.section.tableSetting.modal.tableName.en.required': '英文桌名不能为空',
  'reservationSettings.section.tableSetting.modal.seatingCapacity.range.error': `就餐人数(min)不能超过就餐人数(max)`,
  'reservationSettings.section.tableSetting.modal.seatingCapacity.overlap.error': `就餐人数范围和现有的发生重叠`,

  'reservationSettings.section.tableSetting.modal.Duration': '翻台时间',
  'reservationSettings.section.tableSetting.modal.Duration.unit': '分钟',
  'reservationSettings.section.tableSetting.modal.Duration.required': '翻台时间不能为空',

  'reservationSettings.section.tableSetting.modal.edit.title': '编辑桌型',

  'reservationSettings.section.tableSetting.delete.title': '确定要删除这个桌型吗？',

  'reservationSettings.section.tableSetting.delete.comfirm': '确定，删除',
  'reservationSettings.section.tableSetting.delete.cancel': '取消',

  'reservationSettings.section.tableSetting.delete.success': '删除桌型成功',
  'reservationSettings.section.tableSetting.delete.failed': '删除桌型失败',

  'reservationSettings.section.tableSetting.add.success': '添加桌型成功',
  'reservationSettings.section.tableSetting.add.failed': '添加桌型失败',

  'reservationSettings.section.tableSetting.edit.success': '更新桌型成功',
  'reservationSettings.section.tableSetting.edit.failed': '更新桌型失败',

  'reservationSettings.section.openTimeRegular': '开放时间(常规)',
  'reservationSettings.section.openTimeRegular.table.column.weeks': '日期',
  'reservationSettings.section.openTimeRegular.table.column.time': '时间',
  'reservationSettings.section.openTimeRegular.table.column.tableSource': '可用桌型和数量',
  'reservationSettings.section.openTimeRegular.table.column.action': '操作',
  'reservationSettings.section.openTimeRegular.addNew.button': '添加',
  'reservationSettings.section.openTimeRegular.edit.button': '编辑',
  'reservationSettings.section.openTimeRegular.delete.button': '删除',

  'reservationSettings.section.openTimeRegular.modal.new.title': '新开放时间(常规)',
  'reservationSettings.section.openTimeRegular.modal.edit.title': '编辑开放时间(常规)',
  'reservationSettings.section.openTimeRegular.modal.time': '时间范围',
  'reservationSettings.section.openTimeRegular.modal.time.error': '请设置开放时间范围',
  'reservationSettings.section.openTimeRegular.modal.weeks.error': '请设置开放日期范围',
  'reservationSettings.section.openTimeRegular.modal.tables.error': '请设置开放日期内可用的桌型',

  'reservationSettings.section.openTimeRegular.modal.overlap.error': '其他开放时间(常规)冲突',

  'reservationSettings.section.openTimeRegular.delete.title': '确定要删除开放时间设置吗？',

  'reservationSettings.section.openTimeRegular.delete.comfirm': '确定，删除',
  'reservationSettings.section.openTimeRegular.delete.cancel': '取消',

  'reservationSettings.section.openTimeRegular.delete.success': '删除开放时间设置成功',
  'reservationSettings.section.openTimeRegular.delete.failed': '删除开放时间设置失败',

  'reservationSettings.section.openTimeRegular.add.success': '添加开放时间设置成功',
  'reservationSettings.section.openTimeRegular.add.failed': '添加桌开放时间设置失败',

  'reservationSettings.section.openTimeRegular.edit.success': '更新开放时间设置成功',
  'reservationSettings.section.openTimeRegular.edit.failed': '更新开放时间设置失败',

  'reservationSettings.section.openTimeSpecial': '开放时间(特定)',
  'reservationSettings.section.openTimeSpecial.table.column.date': '日期',
  'reservationSettings.section.openTimeSpecial.table.column.time': '时间',
  'reservationSettings.section.openTimeSpecial.table.column.tableSource': '可用桌型和数量',
  'reservationSettings.section.openTimeSpecial.table.column.action': '操作',
  'reservationSettings.section.openTimeSpecial.addNew.button': '添加',
  'reservationSettings.section.openTimeSpecial.edit.button': '编辑',
  'reservationSettings.section.openTimeSpecial.delete.button': '删除',

  'reservationSettings.section.openTimeSpecial.delete.title': '确定要删除开放时间设置吗？',
  'reservationSettings.section.openTimeSpecial.delete.comfirm': '确定，删除',
  'reservationSettings.section.openTimeSpecial.delete.cancel': '取消',
  'reservationSettings.section.openTimeSpecial.delete.success': '删除开放时间设置成功',
  'reservationSettings.section.openTimeSpecial.delete.failed': '删除开放时间设置失败',

  'reservationSettings.section.openTimeSpecial.add.success': '添加开放时间设置成功',
  'reservationSettings.section.openTimeSpecial.add.failed': '添加开放时间设置失败',

  'reservationSettings.section.openTimeSpecial.edit.success': '更新开放时间设置成功',
  'reservationSettings.section.openTimeSpecial.edit.failed': '更新开放时间设置失败',

  'reservationSettings.section.openTimeSpecial.modal.new.title': '新开放时间(特定)',
  'reservationSettings.section.openTimeSpecial.modal.edit.title': '编辑开放时间(特定)',
  'reservationSettings.section.openTimeSpecial.modal.date': '日期范围',
  'reservationSettings.section.openTimeSpecial.modal.time': '时间范围',
  'reservationSettings.section.openTimeSpecial.modal.time.error': '请设置开放时间范围',
  'reservationSettings.section.openTimeSpecial.modal.date.error': '请设置开放日期范围',
  'reservationSettings.section.openTimeSpecial.modal.tables.error': '请设置开放日期内可用的桌型',

  'reservationSettings.section.openTimeSpecial.modal.overlap.error': '与其他开放时间(特定)冲突',

  'reservationSettings.section.closeTime': '不可预订时间',
  'reservationSettings.section.closeTime.table.column.startDatetime': '开始',
  'reservationSettings.section.closeTime.table.column.endDateTime': '结束',
  'reservationSettings.section.closeTime.table.column.action': '操作',
  'reservationSettings.section.closeTime.addNew.button': '添加',
  'reservationSettings.section.closeTime.edit.button': '编辑',
  'reservationSettings.section.closeTime.delete.button': '删除',

  'reservationSettings.section.closeTime.delete.title': '确定要删除不可预订时间设置吗？',
  'reservationSettings.section.closeTime.delete.comfirm': '确定，删除',
  'reservationSettings.section.closeTime.delete.cancel': '取消',
  'reservationSettings.section.closeTime.delete.success': '删除不可预订时间成功',
  'reservationSettings.section.closeTime.delete.failed': '删除不可预订时间失败',

  'reservationSettings.section.closeTime.add.success': '添加不可预订时间成功',
  'reservationSettings.section.closeTime.add.failed': '添加不可预订时间失败',

  'reservationSettings.section.closeTime.edit.success': '更新不可预订时间成功',
  'reservationSettings.section.closeTime.edit.failed': '更新不可预订时间失败',

  'reservationSettings.section.closeTime.modal.new.title': '新的不可预订时间',
  'reservationSettings.section.closeTime.modal.edit.title': '编辑不可预订时间',
  'reservationSettings.section.closeTime.modal.date': '日期/时间',
  'reservationSettings.section.closeTime.modal.date.error': '请设置不可预订时间范围',
  'reservationSettings.section.closeTime.modal.date.overlap': '设置的不可预订时间范围和其他不可预订时间冲突',

  'reservationSettings.section.leadtime': '提前时间',
  'reservationSettings.section.leadtime.time': '最短可提前预约时间',
  'reservationSettings.section.leadtime.time.days': '天',
  'reservationSettings.section.leadtime.time.hours': '小时',
  'reservationSettings.section.leadtime.time.minutes': '分钟',
  'reservationSettings.section.leadtime.day': '可提前预约天数',
  'reservationSettings.section.leadtime.day.tips': '仅对网页预约和谷歌预约生效',
  'reservationSettings.section.leadtime.day.days': '天',
  'reservationSettings.section.leadtime.time.required': '请设置最短可提前预约时间',
  'reservationSettings.section.leadtime.day.required': '请设置可提前预定天数',
  'reservationSettings.section.leadtime.day.time.error': '可提前预定天数不能小于最短可提前预约时间',
  'reservationSettings.section.leadtime.time.day.error': '最短可提前预约时间不能大于可提前预定天数',

  'reservationSettings.section.notifytime': '自动提醒时间设置',
  'reservationSettings.section.notifytime.time': '预约提醒时间',
  'reservationSettings.section.notifytime.time.days': '天',
  'reservationSettings.section.notifytime.time.hours': '小时',
  'reservationSettings.section.notifytime.time.minutes': '分钟',
  'reservationSettings.section.notifytime.time.required': '请设置自动预约提醒时间',

  'reservationSettings.section.cancelNotify': '餐厅取消预约通知设置',
  'reservationSettings.section.cancelNotify.field.note': '备注 - 英',
  'reservationSettings.section.cancelNotify.field.note.foreign': '备注 - 中',
  'reservationSettings.section.cancelNotify.field.note.foreign.limit': '中文65个字符上限',
  'reservationSettings.section.cancelNotify.field.note.limit': '英文150个字符上限',
  'reservationSettings.section.cancelNotify.field.note.placeholder': '请输入英文取消通知内容',
  'reservationSettings.section.cancelNotify.field.note.foreign.placeholder': '请输入中文取消通知内容',

  'reservationSettings.section.notes': '预约须知',

  'reservationSettings.section.notes.field.note': '须知 - 英',
  'reservationSettings.section.notes.field.note.foreign': '须知 - 中',
  'reservationSettings.section.notes.field.note.placeholder': '请输入英文预约须知内容',
  'reservationSettings.section.notes.field.note.foreign.placeholder': '请输入中文预约须知内容',

  'reservationSettings.section.enable.autosendNotification': '自动发送预约提醒',
  'reservationSettings.section.enable.autosendNotification.desc': '打开后,将根据设置的自动提醒时间发送提醒短信',

  'reservationSettings.section.showEstimateDiningTime': '显示预计用餐时长',
  'reservationSettings.section.enable.showEstimateDiningTime': '显示预计用餐时长',
  'reservationSettings.section.enable.showEstimateDiningTime.desc': `将在预约、入座的用户卡片，以及桌型图中，显示预计用餐时长`,

  'reservationSettings.section.enable.google.reservation.error':
    '请先设置允许在线预约的桌型、常规开放时间和可在线预约人数',
  'reservationSettings.section.enable.google.reservation.error.igot.button': '我知道了',
};
